"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OSInfo = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _Enums = require("../Common/Enums");

// Ported from https://dev.azure.com/dynamicscrm/OneCRM/_git/CRM.OmniChannel.LiveChatWidget?path=/src/LiveChatLoader/Utility/OSInfo.ts&version=GBrelease
var OSInfo = /*#__PURE__*/function () {
  function OSInfo() {
    (0, _classCallCheck2["default"])(this, OSInfo);
  }

  (0, _createClass2["default"])(OSInfo, null, [{
    key: "getOsType",
    value: function getOsType() {
      var win = /(windows|win32)/i;
      var winrt = / arm;/i;
      var winphone = /windows\sphone\s\d+\.\d+/i;
      var osx = /(macintosh|mac os x)/i;
      var ios = /(iPad|iPhone|iPod)(?=.*like Mac OS X)/i;
      var linux = /(linux|joli|[kxln]?ubuntu|debian|[open]*suse|gentoo|arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|cros)/i;
      var android = /android/i;

      var userAgent = function userAgent() {
        return window.navigator.userAgent;
      };

      if (userAgent().match(winphone)) {
        return _Enums.OperatingSystem.WINDOWS_PHONE;
      }

      if (userAgent().match(winrt)) {
        return _Enums.OperatingSystem.WINDOWS_RT;
      }

      if (userAgent().match(ios)) {
        return _Enums.OperatingSystem.IOS;
      }

      if (userAgent().match(android)) {
        return _Enums.OperatingSystem.ANDROID;
      }

      if (userAgent().match(linux)) {
        return _Enums.OperatingSystem.LINUX;
      }

      if (userAgent().match(osx)) {
        return _Enums.OperatingSystem.MACOSX;
      }

      if (userAgent().match(win)) {
        return _Enums.OperatingSystem.WINDOWS;
      }

      return _Enums.OperatingSystem.UNKNOWN;
    }
  }]);
  return OSInfo;
}();

exports.OSInfo = OSInfo;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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